import { Object3D } from 'three';
import * as THREE from 'three/build/three.module';
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { InternalAction } from './J3TypeList';

export class J3ModelHelper extends EventTarget {

    currentModel = null;    //現在のモデル
    currentIndex = 0;    //現在のコンフィグレーションインデックス
    models = [];    //モデルデータの配列
    loadedNumber = 0;   //ロードしたモデル数
    numberToLoad: number;  //ロードすべきモデル数
    wrapper: Object3D;   //親オブジェクト

    constructor(num: number, public initialIndex = 0, public directory = './models/') {
        super();
        this.models = new Array(num);
    }

    LoadModelData(wrapper, data, useDRACO=false) {
        this.numberToLoad = data.length;
        this.wrapper = wrapper;
        let j = 0;
        for (const elem of data) {
            if (elem.load) {
                const ext = elem.name.split('.')[1];
                console.log('LoadModelData', ext);
                if (ext == 'gltf' || ext == 'glb') {
                    if(elem.useDRACO){
                        this.LoadDRACO(j, wrapper, elem.name, elem.scale, elem.position, elem.rotation, elem.visible, elem.tagid);
                    }else{
                        this.LoadGLTF(j, wrapper, elem.name, elem.scale, elem.position, elem.rotation, elem.visible, elem.tagid);
                    }
                } else if (ext == 'fbx') {
                    this.LoadFBX(j, wrapper, elem.name, elem.scale, elem.position, elem.rotation, elem.visible, elem.tagid);
                }
                //console.log('data', elem.name);
            }
            j++;
        }
    }


    LoadGLTFs(wrapper, data) {
        this.numberToLoad = data.length;
        this.wrapper = wrapper;
        let j = 0;
        for (const elem of data) {
            if (elem.load) {
                //console.log('data', elem.name);
                this.LoadGLTF(j, wrapper, elem.name, elem.scale, elem.position, elem.rotation, elem.visible, elem.tagid);
            }
            j++;
        }
    }

    LoadDRACO(num: number, parent: THREE.Object3D, modelName: string, scl = [1, 0, 1.0, 1.0], pos = [0, 0, 0], rot = [0, 0, 0], visible = true, tagID = 'NONE') {

        const loader = new DRACOLoader();
        // Specify path to a folder containing WASM/JS decoding libraries.
        loader.setDecoderPath( 'js/libs/draco/gltf/' );
        loader.setDecoderConfig({type: 'js'});
        // Optional: Pre-fetch Draco WASM/JS module.
        loader.preload();
        loader.load(this.directory + modelName, (data) => {
            console.log('LoadDRACO', modelName);
            this.AfterLoad(num, parent, data, scl, pos, rot, visible, tagID);
        }, undefined, (e) => {
            console.log(e);
        });
    }

    LoadGLTF(num: number, parent: THREE.Object3D, modelName: string, scl = [1, 0, 1.0, 1.0], pos = [0, 0, 0], rot = [0, 0, 0], visible = true, tagID = 'NONE') {

        const loader = new GLTFLoader();
        loader.load(this.directory + modelName, (data) => {
            console.log('LoadGLTF', modelName);
            this.AfterLoad(num, parent, data, scl, pos, rot, visible, tagID);
        }, undefined, (e) => {
            console.log(e);
        });
    }

    LoadFBX(num: number, parent: THREE.Object3D, modelName: string, scl = [1, 0, 1.0, 1.0], pos = [0, 0, 0], rot = [0, 0, 0], visible = true, tagID = 'NONE') {

        const loader = new FBXLoader();
        loader.load(this.directory + modelName, (data) => {
            console.log('LoadFBX', modelName);
            this.AfterLoad(num, parent, data, scl, pos, rot, visible, tagID);
        }, undefined, (e) => {
            console.log(e);
        });
    }

    SetVisibility(value: boolean) {
        this.currentModel.visible = value;
    }

    Select(index = 0) {
        //モデルタイプの選択
        if (this.models.length < 2) return;    //モデルが０個か１個の場合は何もしない
        if (index < 0 || index > this.models.length - 1) return;
        const currentVisibility = this.currentModel.visible;    //現在のモデルの表示・非常時状態を一時保存
        //console.log('J3ModelHelper.Select', this.models.length, index, currentVisibility);

        for (let i = 0; i < this.models.length; i++) {
            if (i == index) {
                this.currentIndex = index;
                //console.log('Select', index, currentVisibility);
                this.currentModel = this.models[i];     //現在のモデルを入れ替える
                this.currentModel.model.visible = currentVisibility;  //現在のモデルの表示・非常時状態を復元
                const isMin = (index <= 0) ? true : false;
                const isMax = (index >= this.models.length - 1) ? true : false;
                //console.log('this.models.length', this.models.length);
                const event = new CustomEvent("Change", { detail: { index: index, isMin: isMin, isMax: isMax, tagID: this.currentModel.tagID } });
                this.dispatchEvent(event);
            } else {
                if(this.models[i]) this.models[i].model.visible = false; //対象外のモデルは非表示にする
            }
        }
    }

    Next() {
        this.Select(this.currentIndex + 1);
    }
    Prev() {
        this.Select(this.currentIndex - 1);
    }

    AfterLoad(num: number, parent: THREE.Object3D, modeldata, scl, pos, rot, visible, tagID) {
        this.loadedNumber++;    //ロードした数をインクリメント
        if (this.loadedNumber == this.numberToLoad) {
            console.log('LoadComplete', this.loadedNumber);
            const event1 = new CustomEvent('LoadComplete');
            this.dispatchEvent(event1);
        }

        // モデルデータ読み込み後にシーンに追加
        const model = modeldata.scene;
        model.scale.set(scl[0], scl[1], scl[2]);
        model.position.set(pos[0], pos[1], pos[2]);
        const f = Math.PI/180;
        model.rotation.set(f*rot[0], f*rot[1], f*rot[2]);

        if (num == this.initialIndex) {
            model.visible = visible;    //指定インデックスでは表示設定にあわせる
            this.currentModel = model;
            this.currentIndex = num;
            const isMin = (num <= 0) ? true : false;
            const isMax = (num >= this.models.length - 1) ? true : false;
            console.log('this.models.length', this.models.length);
            const event = new CustomEvent('Change', { detail: { index: num, isMin: isMin, isMax: isMax } });
            this.dispatchEvent(event);
        } else {
            model.visible = false;  //指定インデックス以外は非表示にする
        }

        //調査・マテリアルの変更
        model.traverse((obj) => {
            if (obj.isMesh) {
                obj.material.transparent = true;
                obj.material.opacity = 1.0;
            }
        });

        parent.add(model);
        //console.log('AfterLoad', num, tagID);
        this.models[num] = { model: model, tagID: tagID };
    }

    Rotate(rotSpeed = [0.0, 0.1, 0.0]) {
        if (this.currentModel) {
            this.currentModel.rotation.x += rotSpeed[0];
            this.currentModel.rotation.y += rotSpeed[1];
            this.currentModel.rotation.z += rotSpeed[2];
        }
    }

    SetOpacity(opacity = 1.0) {
        for (const elem of this.models) {
            elem.model.traverse((obj) => {
                if (obj.isMesh) {
                    obj.material.transparent = true;
                    obj.material.opacity = opacity;
                }
            });
        }
    }

    GetOpacity(): number {
        let opacity = 1.0;
        this.currentModel.traverse((obj) => {
            if (obj.isMesh) {
                opacity = obj.material.opacity;
            }
        })
        return opacity;
    }

    Show() {
        this.SetVisibility(true);
    }

    Hide() {
        this.SetVisibility(false);
    }

    DisposeAll() {
        for (const model of this.models) {
            console.log('DisposeAll', model.tagID);
            this.wrapper.remove(model.model);
            model.model.traverse((obj) => {
                if (obj.isMesh) {
                    obj.material.dispose();
                    obj.geometry.dispose();
                }
            });

            console.log(model.name, 'disposed');

            const action: InternalAction = 'dispose';
            const event = new CustomEvent(action, { detail: { objectname: model.name } });
            this.dispatchEvent(event);
            //上位モジュールで、renderer.renderLists.dispose(); をコールする
        }
    }
}